import { render, staticRenderFns } from "./SHotZone.vue?vue&type=template&id=35b84f4a&scoped=true"
import script from "./SHotZone.vue?vue&type=script&lang=js"
export * from "./SHotZone.vue?vue&type=script&lang=js"
import style0 from "./SHotZone.vue?vue&type=style&index=0&id=35b84f4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b84f4a",
  null
  
)

export default component.exports